import PropTypes from 'prop-types'
import React from 'react'
import { FlatButton } from 'material-ui'
import ContactToUpdate from './ContactToUpdate'
import './callLogPopover.css'

const UpdateContactList = ({
  matchingContacts,
  handleExistingContactClick,
  handleNewContactClick,
  onDiscardClick,
  onBackClick,
}) => {
  const contactsList = matchingContacts.map(
    contact => (
      <ContactToUpdate
        key={`${contact.first_name}${contact.last_name}${contact.email}`}
        contact={contact}
        handleClick={handleExistingContactClick}
      />
    ),
  )

  return (
    <div className="popover">
      <p>Would you like to update an existing contact?</p>
      {contactsList}
      <div
        className="contactEntry"
        onClick={handleNewContactClick}
        role="button"
        tabIndex="-1"
      >
        <h3 className="contactText">New Entry</h3>
      </div>
      <div className="buttons">
        <FlatButton
          label="Discard"
          secondary
          className="deleteButton"
          onClick={onDiscardClick}
        />
        <FlatButton
          label="Back"
          onClick={onBackClick}
        />
      </div>
    </div>
  )
}

UpdateContactList.propTypes = {
  matchingContacts: PropTypes.array.isRequired,
  handleExistingContactClick: PropTypes.func.isRequired,
  handleNewContactClick: PropTypes.func.isRequired,
  onDiscardClick: PropTypes.func.isRequired,
  onBackClick: PropTypes.func.isRequired,
}

export default UpdateContactList



// WEBPACK FOOTER //
// ./src/components/CallLog/ContactPopover/UpdateContactList.js